import {
  DefaultActionsErrorView,
  ErrorBoundary,
  LoaderCentered,
} from '@modules/components';
import RemoteOrders from '@modules/remotes/orders';
import { Suspense } from 'react';

export function AdmModuleOrders() {
  return (
    <ErrorBoundary fallback={<DefaultActionsErrorView />}>
      <Suspense fallback={<LoaderCentered />}>
        <RemoteOrders />
      </Suspense>
    </ErrorBoundary>
  );
}
